var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedMotor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_13925_128783)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7972 7.58074H18.7006C18.2034 6.64437 17.18 6 16 6C14.82 6 13.7965 6.64437 13.2993 7.58074H10.2027C9.81468 7.58074 9.5 7.87871 9.5 8.24625C9.5 8.61386 9.81468 8.91184 10.2027 8.91184H12.9797C12.9824 9.06107 12.9973 9.20746 13.0233 9.35036C11.6765 9.60901 10.6595 10.739 10.6595 12.0899V19.9102C10.6595 21.4348 11.955 22.6775 13.5581 22.7043V23.8037C13.5581 25.0147 14.5984 26 15.877 26H16.123C17.4016 26 18.4418 25.0147 18.4418 23.8037V22.7043C20.0449 22.6775 21.3405 21.4348 21.3405 19.9102V12.0899C21.3405 10.739 20.3235 9.60894 18.9767 9.35029C19.0027 9.2074 19.0176 9.061 19.0203 8.91177H21.7973C22.1853 8.91177 22.5 8.6138 22.5 8.24619C22.4999 7.87865 22.1853 7.58074 21.7972 7.58074ZM16 7.33111C16.8912 7.33111 17.6162 8.01777 17.6162 8.86188C17.6162 9.70598 16.8912 10.3926 16 10.3926C15.1088 10.3926 14.3838 9.70598 14.3838 8.86188C14.3838 8.01777 15.1088 7.33111 16 7.33111ZM17.0364 23.8036C17.0364 24.2807 16.6266 24.6689 16.1229 24.6689H15.877C15.3732 24.6689 14.9634 24.2807 14.9634 23.8036V20.2762C14.9634 19.7991 15.3732 19.4109 15.877 19.4109H16.1229C16.6266 19.4109 17.0364 19.7991 17.0364 20.2762V23.8036ZM18.3891 10.6256C19.2415 10.6256 19.935 11.2824 19.935 12.0898V19.9101C19.935 20.7007 19.2699 21.3465 18.4417 21.373V20.2762C18.4417 19.0651 17.4015 18.0798 16.1229 18.0798H15.877C14.5983 18.0798 13.558 19.0651 13.558 20.2762V21.373C12.73 21.3466 12.0648 20.7008 12.0648 19.9101V12.0899C12.0648 11.2825 12.7583 10.6256 13.6107 10.6256H13.623C14.1766 11.2935 15.036 11.7238 16 11.7238C16.9639 11.7238 17.8233 11.2935 18.377 10.6256H18.3891V10.6256Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13925_128783",
    x1: 6.5,
    y1: 1.73925e-7,
    x2: 23,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8746A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455237,
    stopColor: "#F4385A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#902B23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMotor);
export default __webpack_public_path__ + "static/media/redMotor.0a32f800a2d1ef90f61b7c61e5f5f4b4.svg";
export { ForwardRef as ReactComponent };